import React from 'react';
import './em-card.css';
import PeriodList from '../../Period-Dropdown-list/period-dropdown-list';

function Card_3(props) {
  const { widgetName, component, applystyle, applyScroll, isTimePeriod } = props;

  return (
    <div className={widgetName == "Energy Monitoring" ? 'em-card-wide' : 'em-card'} >

      <div className='em-card-header'>
        <div className='em-card-title'>
          {widgetName}
        </div>
        {/* <div className='em-card-update-notification'>
           
        </div> */}
      </div>
      <hr />
      {/* {isTimePeriod ? <PeriodList /> : ""} */}
      {applyScroll ? <div className="em-card-content em-card-content-scroll" >
        {component}
      </div> :
        <div className={applystyle ? 'em-card-content em-card-content-even-align' : 'em-card-content'} >
          {component}
        </div>
      }
    </div>
  );
}

export default Card_3;


